<template>
	<el-dialog :visible="show" append-to-body :title="row ? '修改分类' : '新增分类'" :close-on-click-modal="false" width="500px" @close="closeDialog">
		<el-form ref="vForm" label-width="80px" :model="vForm">
			<el-form-item label="排序" prop="sort" :rules="{ required: true, message: '排序必填' }">
				<el-input v-model="vForm.sort"></el-input>
				<div class="v-form-tips">数值越小越靠前</div>
			</el-form-item>
			<el-form-item label="全称" prop="name" :rules="{ required: true, message: '全称必填' }">
				<el-input v-model="vForm.name"></el-input>
				<div class="v-form-tips">电脑端显示</div>
			</el-form-item>
			<el-form-item label="简称" prop="alias" :rules="{ required: true, message: '简称必填' }">
				<el-input v-model="vForm.alias"></el-input>
				<div class="v-form-tips">手机端显示</div>
			</el-form-item>
			<el-form-item label="图标" prop="icon" :rules="{ required: true, message: '图标必填' }">
				<v-upload-image v-model="vForm.icon" width="100px" height="100px" @change="$refs.vForm.validateField('icon')" />
				<div class="v-form-tips">尺寸100*100px</div>
			</el-form-item>
			<el-form-item label="图标颜色">
				<el-color-picker v-model="vForm.color"></el-color-picker>
				<div class="v-form-tips">地图图标及文字显示颜色</div>
			</el-form-item>
			<el-form-item label="文字颜色">
				<el-color-picker v-model="vForm.txtColor"></el-color-picker>
				<div class="v-form-tips">单独设置当前分类在手机端筛选栏中的文字颜色；留空则使用分类设置中的默认颜色</div>
			</el-form-item>
			<el-form-item label="显示样式">
				<el-radio v-model="vForm.mapType" :label="1">有图标背景</el-radio>
				<el-radio v-model="vForm.mapType" :label="2">透明背景</el-radio>
        <div class="v-form-tips">
          设置为不显示背景，图标在地图与手机端筛选展示界面均不显示背景
        </div>
			</el-form-item>
			<el-form-item v-if="vForm.mapType == 2" label="图标禁用" prop="iconGray" :rules="{ required: true, message: '图标禁用必填' }">
				<v-upload-image v-model="vForm.iconGray" width="100px" height="100px" @change="$refs.vForm.validateField('iconGray')" />
				<div class="v-form-tips">尺寸100*100px</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="closeDialog">关闭</el-button>
			<el-button type="primary" :loading="doSubmitLoading" size="small" @click="doSubmit">
				确 定
			</el-button>
		</div>
	</el-dialog>
</template>

<script>

	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			row: {
				type: Object,
				default: () => ({})
			}
		},

		data() {
			return {
				doSubmitLoading: false,
				vForm: {
					id: "",
					name: "",
					icon: '',
					color: '#409EFF',
					txtColor: '',
					iconGray: '',
					btn: '',
					alias: '',
					sort: 0,
					mapType:1,//1常规 2不显示外框样式
				},

			};
		},

		created() {
			if (this.row) {
				for (let key in this.vForm) {
					this.vForm[key] = this.row[key];
				}
			}
		},

		methods: {

			closeDialog() {
				this.$emit("update:show", false);
			},

			//提交表单
			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					await this.api.category[this.row ? "edit" : "add"](this.vForm);
					this.$message.success(!this.row ? "添加成功" : "修改成功");
					this.$emit("success", this.row ? "" : 1);
					this.closeDialog();
				} catch (e) {
					console.error(e);
				}
				this.doSubmitLoading = false;
			}
		}
	};
</script>
